module.exports = __webpack_public_path__ + "static/img/advantage2.50b09c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tech/advantage2.png
// module id = A8K8
// module chunks = 11